module.exports = __webpack_public_path__ + "img/paymentMethod.87a1eea6.png";